module.exports = __webpack_public_path__ + "static/media/s_12.dace974e.mp3";